import React from "react";
import { Modal, Box, Typography, Tooltip } from "@mui/material";
import DataTable from "../DataTable/DataTable";
import { IoClose } from "react-icons/io5";

export default function CreditNoteDetailsModal({ open, handleClose, creditNotes }) {
  const columns = [
    { field: "doc_id", headerName: "Doc ID", width: 120 },
    { field: "doc_date", headerName: "Doc Date", width: 140 },
    { field: "service_name", headerName: "Service Name", width: 180 },
    { field: "pip_port_description", headerName: "Description", width: 180 },
    { field: "location_id", headerName: "Location ID", width: 130 },
    { field: "contract_sof_number", headerName: "Contract SOF Number", width: 180 },
    { field: "currency", headerName: "Currency", width: 120 },
      {
    field: "amount",
    headerName: "Amount",
    width: 120,
    renderHeader: () => (
      <strong 
    //   style={{ color: "#1976d2" }}
      >Amount
        </strong>
    ),
    renderCell: (params) => (
      <strong style={{ color: "#2e7d32" }}>
        {params.value}
      </strong>
    ),
  },
    // { field: "amount", headerName: "Amount", width: 120 },
    { field: "taxes_surcharges", headerName: "Taxes & Surcharges", width: 160 },
    { field: "total_usd", headerName: "Total (USD)", width: 130 },
    { 
      field: "conversion_rate", 
      headerName: "Conversion Rate", 
      width: 150,
      renderCell: (params) => {
        const val = params.value;
        if (val === null || val === undefined || val === "N/A" || val === "") return "N/A";
        const num = Number(val);
        if (isNaN(num)) return val;
        const formatted = parseFloat(num.toFixed(3)).toString();
        return (
          <Tooltip title={String(val)} arrow placement="top">
            <span style={{ cursor: "pointer", borderBottom: "1px dashed #7C2EA0" }}>
              {formatted}
            </span>
          </Tooltip>
        );
      }
    },
    { field: "converted_total_usd", headerName: "Converted Total USD", width: 180 },
    { field: "page_number", headerName: "Page Number", width: 130 },
  ];

  const rows = creditNotes?.map((item, index) => ({
    id: index,
    doc_id: item?.doc_id || "N/A",
    doc_date: item?.doc_date || "N/A",
    service_name: item?.service_name || "N/A",
    pip_port_description: item?.pip_port_description || "N/A",
    location_id: item?.location_id || "N/A",
    contract_sof_number: item?.contract_sof_number || "N/A",
    currency: item?.currency || "N/A",
    amount: item?.amount ? parseFloat(item.amount).toFixed(2) : "0.00",
    taxes_surcharges: item?.taxes_surcharges
    ? parseFloat(item.taxes_surcharges).toFixed(2)
    : "0.00",
    total_usd: item?.total_usd ? parseFloat(item.total_usd).toFixed(2) : "0.00",
    conversion_rate: item?.conversion_rate || "N/A",
    converted_total_usd: item?.converted_total_usd || "N/A",
    page_number: item?.page_number || "N/A",
  }));


//   contract_sof_number
//   currency               Done
//   page_number            Done
// conversion_rate          Done
// converted_total_usd      Done

  return (
    <Modal
      open={open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") handleClose(e);
      }}
      style={{ zIndex: 99 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          width: "90%",
          maxWidth: "1000px",
          borderRadius: 2,
          overflowY: "auto",
          zIndex: 99,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6" sx={{ fontSize: "24px" }}>
            Credit Note Details
          </Typography>
          <IoClose size={24} onClick={handleClose} style={{ cursor: "pointer" }} />
        </div>
        <DataTable columns={columns} rows={rows} />
      </Box>
    </Modal>
  );
}
